{
    "origins": [
        "https://dev.bigheartapp.org",
        "https://app.dev.bighearthealth.com",
        "https://admin.dev.bigheartapp.org",
        "https://ehr.dev.bighearthealth.com"
    ]
}
